import { readableFileSizeFromBytes } from '@/utils/vuex';
import { mapState } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';

const MAX_BYTE_PER_ATTACHMENT = 10000000;

export default {
  props: {
    editedItem: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data: function () {
    return {
      formSaving: false,
      formValid: false,
      formItem: {},
      regions: [
        { id: 'EU868', title: 'EU 868 Mhz Freq. Band' },
        { id: 'US915', title: 'US 915 Mhz Freq. Band' },
        { id: 'AU915', title: 'Australia 915 Mhz Freq. Band' },
        { id: 'IN865', title: 'India 915 Mhz Freq. Band' },
        { id: 'AS923', title: 'Asia 923 Mhz Freq. Band' },
      ],
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions']),
    n1Protocol() {
      return window.location.protocol.replace(':', '');
    },
    n1Host() {
      return window.location.host;
    },
    requiredRule() {
      return [(v) => !!v || this.$i18n_t('Common.fieldRequired')];
    },
    cloading() {
      return this.$store.state.app.loading;
    },
    isIotHubManager() {
      return this.permissions['IotHub.manage'];
    },
    isAdmin() {
      return this.permissions['all.manage'];
    },
    formCardButtons() {
      return [
        {
          icon: 'fas fa-save',
          title: this.formItem.id ? this.$i18n_t('Common.save') : this.$i18n_t('Common.saveAndCreate'),
          type: this.isIotHubManager ? 'submit' : 'button',
          valid: this.isIotHubManager ? undefined : false,
        },
        {
          icon: 'fal fa-times',
          color: 'danger',
          action: 'close',
          tooltip: this.$i18n_t('Common.cancel'),
        },
      ];
    },
  },
  watch: {
    editedItem() {
      this.formItem = cloneDeep(this.editedItem);
    },
  },
  methods: {
    niota1ImageUrl(imagePath) {
      if (imagePath) {
        if (/^http(?:s):\/\//i.test(imagePath)) {
          return imagePath;
        }
        return `${location.origin}${imagePath}`;
      }
      return '';
    },
    save() {
      let promise = undefined;
      let operation = undefined;
      this.formSaving = true;
      this.formValid = false;

      if (this.formItem.id) {
        promise = this.updateRequest();
        operation = 'update';
      } else {
        promise = this.createRequest();
        operation = 'create';
      }
      promise
        .then((res) => {
          this.$snack(this.$i18n_t(`NiotaClassic.Originators.snacks.${operation}Success`), 'success');
          // only close form on success
          // If Consumer go to details
          if (res.data.consumer) {
            this.pushToRouter(`/niota-classic/consumers/${res.data.consumer.id}`);
          }
          this.$emit('close', operation);
        })
        .catch((error) => {
          if (get(error, 'response.data.err')) {
            if (this.$i18n_te(`Error.${error.response.data.err}`)) {
              this.$snack(this.$i18n_t(`Error.${error.response.data.err}`), 'error');
            } else {
              this.$snack(get(error, 'response.data.err'), 'error');
            }
          } else {
            this.$snack(this.$i18n_t(`NiotaClassic.Originators.snacks.${operation}Failed`), 'error');
          }
        })
        .finally(() => {
          this.formValid = true;
          this.formSaving = false;
        });
    },

    pushToRouter(path) {
      this.$router.push({ path: path });
    },

    validateFileSizeLimit(file) {
      if (file) {
        if (file.size >= MAX_BYTE_PER_ATTACHMENT) {
          this.errorMessage = this.$i18n_t('NiotaClassic.Originators.attachmentErrorFileTooBig', {
            attachtmentMaxSize: readableFileSizeFromBytes(MAX_BYTE_PER_ATTACHMENT),
          });
          return false;
        }
      }

      return true;
    },
    imageInputChanged() {
      const files = this.$refs.attachmentInput.files;
      if (!this.validateFileSizeLimit(files[0])) {
        this.$refs.attachmentInput.value = '';
        return;
      }
      this.uploadImage(files[0]);
    },
    getRegionText(deviceData) {
      if (deviceData.properties) {
        if (deviceData.properties.region) {
          return this.regions.find((item) => item.id === deviceData.properties.region).title;
        }
      }
      return this.regions.find((item) => item.id === 'EU868').title;
    },
  },
};
